module.exports = __webpack_public_path__ + "img/tu08.3d44493a.png";